(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('StatsMyIDController', StatsMyIDController);

    StatsMyIDController.$inject = ['$http', '$scope', '$state', '$window', 'StatsMyID', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function StatsMyIDController($http, $scope, $state, $window, StatsMyID, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = {
            documentNumber: pagingParams.documentNumber,
            fromDate: pagingParams.fromDate,
            toDate: pagingParams.toDate,
            fromZonedDate: pagingParams.fromZonedDate,
            toZonedDate: pagingParams.toZonedDate,
        };

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus.fromZonedDate = false;
        vm.datePickerOpenStatus.toZonedDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        if (!pagingParams.firstRun) {
            loadAll();
        }

        function getDateTimeFromPicker() {
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'fromZonedDate') {
                    vm.searchQuery.fromDate = $(this).val();
                } else if ($(this).attr('name') == 'toZonedDate') {
                    vm.searchQuery.toDate = $(this).val();
                }
            });
        }

        function loadAll() {
            StatsMyID.query({
                documentNumber: vm.searchQuery.documentNumber,
                fromZonedDate: vm.searchQuery.fromZonedDate,
                toZonedDate: vm.searchQuery.toZonedDate,
                fromDate: vm.searchQuery.fromDate === '' ? null : vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate === '' ? null : vm.searchQuery.toDate,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
                if (vm.predicate !== 'count(myID.id)') {
                    result.push('count(myID.id)');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.myIDCount = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                documentNumber: vm.searchQuery.documentNumber,
                fromZonedDate: vm.searchQuery.fromZonedDate,
                toZonedDate: vm.searchQuery.toZonedDate,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                firstRun: false
            });
        }

        function search() {
            getDateTimeFromPicker();
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'count(myID.id)';
            vm.reverse = true;
            vm.transition();
        }


        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'count(myID.id)';
            vm.reverse = true;
            vm.searchQuery = {
                documentNumber: null,
                fromZonedDate: null,
                toZonedDate: null,
                fromDate: null,
                toDate: null,
            };
            vm.transition();
        }
    }
})();
